module.exports = __webpack_public_path__ + "static/media/app.35722f9f.png";